import { useMutation } from '@tanstack/react-query';
import { DocumentCallback } from 'react-pdf/dist/cjs/shared/types';

export const useGetPageHeight = (name: string) =>
    useMutation({
        mutationKey: ['agreement', name],
        mutationFn: async (pdf: DocumentCallback) => {
            const pageNumbers = Array.from(new Array(pdf.numPages)).map((_, index) => index + 1);

            const nextPageViewports = await Promise.all(
                pageNumbers.map(async (pageNumber) => {
                    const page = await pdf.getPage(pageNumber);
                    const viewPort = await page.getViewport({ scale: 1 });

                    return viewPort;
                })
            );

            return nextPageViewports;
        },
    });
